import type { Seo } from "types";
import {
  PODSPACE_URL,
  PODSPACE_IMAGE_URL,
  DEFAULT_IMAGE_SRC,
} from "utils/constants";

import { config } from "utils/config";

export const makeId = (length) => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export function numberWithCommas(x) {
  if (x === null || x === undefined) return x;
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// reformat main menus data
const getFormattedMenuItem = (menuItem) => {
  return {
    id: menuItem?.id ?? null,
    title: menuItem?.name ? menuItem?.name?.split("-")[0] : null,
    enable: menuItem?.enable ?? null,
    link: menuItem?.metadata?.content ?? "#",
    // faceToFace: Boolean(menuItem.description),
    faceToFace:
      typeof menuItem?.metadata?.description === "boolean" &&
      menuItem?.metadata?.description,
    children:
      menuItem?.children && menuItem?.children?.length > 0
        ? menuItem.children.map(getFormattedMenuItem)
        : [],
  };
};

const formatMenuList = (children) => {
  const formattedMenus = [];

  children?.forEach?.((v) => {
    // if (v?.name && v?.name?.includes('//')) return;
    const menuItem = getFormattedMenuItem(v);
    formattedMenus.push(menuItem);
  });

  return formattedMenus;
};

export const formatMenus = (response) => {
  if (!response) return [];

  // const mainMenuCatId = 71150;
  const allFaCatId = 73245;
  const mainMenuCatId = 72141;
  const secondMenuCatId = 71152;

  const allFa =
    response?.result?.find((v) => v?.id === allFaCatId)?.children ?? [];
  const mainMenus = formatMenuList(
    allFa?.find((v) => v?.id === mainMenuCatId)?.children ?? []
  );
  const secondMenu = formatMenuList(
    response?.result?.find((v) => v?.id === secondMenuCatId)?.children ?? []
  );
  return [mainMenus, secondMenu];
};

export const formatEnglishMenus = (response) => {
  if (!response) return [];

  const englishPartCatId = 71701;
  const mainMenuCatId = 71702;

  const allEnglishCats =
    response?.result?.find((v) => v?.id === englishPartCatId)?.children ?? [];

  const mainMenus = formatMenuList(
    allEnglishCats?.find((v) => v?.id === mainMenuCatId)?.children ?? []
  );

  return mainMenus;
};

const getFormattedCategoryItem = (menuItem) => ({
  id: menuItem?.id ?? null,
  level: menuItem?.level ?? null,
  title: menuItem?.name ?? null,
  enable: menuItem?.enable ?? null,
});

export const formatCategories = (response) => {
  if (!response) return [];
  const cats = response?.result ?? response ?? [];
  if (!Array.isArray(cats)) return [];
  const formatted = cats.map(getFormattedCategoryItem) ?? [];
  return formatted;
};

//  Convert array to array with another format
export function reformArray(list, structure) {
  // eslint-disable-next-line prefer-const
  let targetArray = [];
  list.forEach((v) => {
    // eslint-disable-next-line prefer-const
    let tempItem = {};
    structure.forEach((s) => {
      tempItem[s.targetIndex] = v[s.index];
    });
    targetArray.push(tempItem);
  });
  return targetArray;
}

export const formatContentItem = (item) => {
  if (!item) return null;
  const result = {
    id: item?.entityId ?? null,
    created_at: item?.metadata?.created?.at ?? null,
    tagTrees: item?.tagTrees ?? [],
    tags: item?.tags ?? [],
    seo: item?.metadata?.seo ?? [],
  };
  item.metadata?.content?.forEach((detail) => {
    result[detail.code] = {
      name: detail?.name,
      value: detail?.value,
      type: detail?.type,
    };
  });
  return result;
};

export const sortDataApi = (data) => {
  // eslint-disable-next-line one-var
  let image = null,
    nameّContent = null,
    images = null,
    title = null,
    title2 = null,
    abstract = null,
    content = null,
    description = null,
    link = null,
    author = null,
    published = null,
    seo_name = null,
    entityId = null,
    file = null,
    source = null,
    start_register = null,
    end_register = null,
    start_event = null,
    end_event = null,
    linkReportImage = null,
    linkReportText = null,
    linkReportVideo = null,
    logo = null;

  let DataTemp = [];
  if (data) {
    if (data.length > 0) {
      data.forEach((element) => {
        nameّContent =
          image =
          images =
          title =
          abstract =
          content =
          description =
          link =
          author =
          published =
          seo_name =
          entityId =
          file =
          source =
          linkReportImage =
          linkReportText =
          linkReportVideo =
          start_register =
          end_register =
          start_event =
          end_event =
          logo =
            null;
        entityId = element?.entityId ?? null;
        nameّContent = element?.name ?? null;
        if (element?.metadata?.content) {
          element.metadata.content.forEach((el) => {
            switch (el.name) {
              case "نویسنده":
                author = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "محتوا":
              case "متن اصلی":
              case "متن خبر":
                content = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "توضیحات":
                description = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "لینک":
              case "لینک منبع":
              case "لینک مرجع":
                link = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "منبع":
                source = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "لینک گزارش تصویری":
                linkReportImage = Array.isArray(el.value)
                  ? el.value[0]
                  : el.value;
                break;
              case "لینک گزارش متنی":
                linkReportText = Array.isArray(el.value)
                  ? el.value[0]
                  : el.value;
                break;
              case "لینک گزارش ویدئویی":
                linkReportVideo = Array.isArray(el.value)
                  ? el.value[0]
                  : el.value;
                break;
              case "عنوان اصلی":
              case "عنوان":
              case "تیتر اصلی":
                title = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "عنوان دوم":
                title2 = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "چکیده":
              case "خلاصه خبر":
              case "چکیده خبر":
                abstract = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "تصویر شاخص":
              case "تصویر اصلی":
              case "فایل تصویر":
                image = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "فایل":
                file = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "نامک":
                seo_name = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "انتشار":
              case "تاریخ انتشار":
                published = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "تاریخ شروع ثبت نام":
                start_register = Array.isArray(el.value)
                  ? el.value[0]
                  : el.value;
                break;
              case "تاریخ پایان ثبت نام":
                end_register = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "تاریخ شروع":
                start_event = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "تاریخ پایان":
                end_event = Array.isArray(el.value) ? el.value[0] : el.value;
                break;
              case "برند":
              case "لوگو":
                logo = Array.isArray(el.value) ? el.value[0] : el.value;
                break;

              default:
                break;
            }
          });
        }
        DataTemp = [
          ...DataTemp,
          {
            entityId,
            nameّContent,
            author,
            content,
            description,
            title,
            title2,
            abstract,
            image,
            images,
            seo_name,
            published,
            link,
            file,
            linkReportImage,
            linkReportText,
            linkReportVideo,
            source,
            start_register,
            end_register,
            start_event,
            end_event,
            logo,
          },
        ];
      });
    }
  }
  return DataTemp.length < 1
    ? [
        {
          entityId,
          nameّContent,
          author,
          content,
          description,
          title,
          abstract,
          image,
          images,
          seo_name,
          published,
          link,
          file,
          linkReportImage,
          linkReportText,
          linkReportVideo,
          source,
          start_register,
          end_register,
          start_event,
          end_event,
          logo,
        },
      ]
    : DataTemp;
};

export const uniqueBy = (data = [], func) => {
  const result = [];
  data.forEach((v) => {
    const foundIndex = result.findIndex((item) =>
      func ? func(item) === func(v) : item === v
    );
    if (foundIndex === -1) result.push(v);
  });
  return result;
};

/**
 * Remove Empty Items of Array
 * @param {Array} list - Array of any
 *
 * @return {Array} Formatted data array
 */
export const removeEmpties = (list) =>
  list.filter((v) => v !== "" && v !== null && v !== undefined);

/**
 * Remove Empty Items of Array
 * @param {Array} list - Array of any
 *
 * @return {Array} Formatted data array
 */
export const removeEmptyOptions = (list) =>
  list.filter(
    (v) =>
      v.value !== "" &&
      v.value !== null &&
      v.value !== undefined &&
      !Number.isNaN(v.value)
  );

const persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
const arabicNumbers = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];

export const fixNumbers = (str) => {
  if (typeof str === "string") {
    for (let i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

/**
 * Returns an array with arrays of the given size.
 *
 * @param myArray {Array} array to split
 * @param chunk_size {Integer} Size of every group
 */
export function chunkArray(myArray, chunk_size) {
  let index = 0;
  const arrayLength = myArray.length;
  const tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
    const myChunk = myArray.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }

  return tempArray;
}

export const formatData = (d) =>
  d?.data?.result && Array.isArray(d.data.result)
    ? d?.data.result.map(formatContentItem)
    : [];

export const formatLogos = (response) => {
  const value = response?.data?.result?.[0];
  return value ? formatContentItem(value) : null;
};

export const getIUMSUrl = (
  method,
  parameters = [],
  service = ["ExternalFacade"]
) => {
  // prettier-ignore
  const paramsString = parameters.length > 0 ? '[' + parameters.map(v => (`\\\\\\\\\\\\\\\"${v}\\\\\\\\\\\\\\\"`)) + ']' : null;
  // prettier-ignore
  const r = `${config.server.url.IUMS_URL}?data={\"type\":3,\"content\":\"{\\\"peerName\\\":\\\"khatam_eng_hq\\\",\\\"receivers\\\":[],\\\"collapseId\\\":null,\\\"groupId\\\":null,\\\"index\\\":null,\\\"messageId\\\":\\\"8657270951\\\",\\\"ttl\\\":60000,\\\"content\\\":\\\"{\\\\\\\"requestHeader\\\\\\\":{\\\\\\\"trackerId\\\\\\\":null,\\\\\\\"token\\\\\\\":null,\\\\\\\"id_token\\\\\\\":null,\\\\\\\"pod_token\\\\\\\":null,\\\\\\\"ssoToken\\\\\\\":null,\\\\\\\"requesterPostId\\\\\\\":0,\\\\\\\"userIds\\\\\\\":null,\\\\\\\"ssoIds\\\\\\\":null},\\\\\\\"messageType\\\\\\\":\\\\\\\"INVOKE_SERVICE\\\\\\\",\\\\\\\"processData\\\\\\\":[],\\\\\\\"content\\\\\\\":\\\\\\\"{\\\\\\\\\\\\\\\"service\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"${service}\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"serviceMethod\\\\\\\\\\\\\\\":\\\\\\\\\\\\\\\"${method}\\\\\\\\\\\\\\\",\\\\\\\\\\\\\\\"parameters\\\\\\\\\\\\\\\":${paramsString ?? "null"},\\\\\\\\\\\\\\\"returnedVarType\\\\\\\\\\\\\\\":null,\\\\\\\\\\\\\\\"returnedVarJson\\\\\\\\\\\\\\\":null,\\\\\\\\\\\\\\\"genericType\\\\\\\\\\\\\\\":null}\\\\\\\",\\\\\\\"engineName\\\\\\\":null,\\\\\\\"peerId\\\\\\\":null,\\\\\\\"asyncTracker\\\\\\\":0,\\\\\\\"trackerId\\\\\\\":null}\\\"}\",\"trackerId\":null}`;
  return r;
};

export const generateImage = (
  hash?: string,
  defaultSrc = DEFAULT_IMAGE_SRC
) => {
  return hash ? `${PODSPACE_IMAGE_URL}/${hash}` : defaultSrc || "";
};

export const generateFile = (hash?: string) => {
  return hash ? `${PODSPACE_URL}/${hash}` : "";
};

export const generateSEO = (seo: Seo): Seo => {
  const result: Seo = {
    ...seo,
  };
  if (seo.canonical) result.canonical = generateCanonical(seo.canonical);
  return result;
};

export const getAllMenuLink = (
  menu: any[],
  baseUrl = "",
  onlyInnerLink = true
) => {
  let result: string[] = [];
  const rec = (arr) => {
    arr?.forEach?.((el) => {
      if (el?.link && el?.link !== "#") {
        result.push(el.link);
      }
      if (Array.isArray(el.children)) {
        rec(el.children);
      }
    });
  };
  menu.forEach((item) => {
    rec(item);
  });
  if (onlyInnerLink) {
    result = result.filter((link) => link.startsWith("/"));
  }

  if (baseUrl) {
    result = result.map((item) => `${baseUrl}${item}`);
  }

  return result;
};

export default {
  removeEmpties,
  removeEmptyOptions,
  makeId,
  numberWithCommas,
  reformArray,
  sortDataApi,
  formatContentItem,
  formatMenus,
  uniqueBy,
  fixNumbers,
  chunkArray,
  formatLogos,
  getIUMSUrl,
  generateImage,
  generateSEO,
  getAllMenuLink,
};
